import { render, staticRenderFns } from "./LookupRadioButton.vue?vue&type=template&id=490ddfca"
import script from "./LookupRadioButton.vue?vue&type=script&lang=ts"
export * from "./LookupRadioButton.vue?vue&type=script&lang=ts"
import style0 from "./LookupRadioButton.vue?vue&type=style&index=0&id=490ddfca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports